<template>
  <div id="app">
    <keep-alive>
      <router-view v-if='$route.meta.keepAlive'></router-view>
    </keep-alive>
    <router-view v-if='!$route.meta.keepAlive'></router-view>
    <div style="position: fixed; bottom: 0; width: 100%; height: 25px; font-size: 12px; display: flex; justify-content: center; align-items: center; background-color: #2d3237;">
      <a href="http://beian.miit.gov.cn" style="color: #999999;">浙ICP备2021025747号</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'app'
  }
</script>

<style lang="less">

  body {
    background-color: #ffffff;
    font-family: "Microsoft Yahei",Helvetica,Arial,sans-serif;
    padding-bottom: 25px;
  }
</style>
